import { prefixerT } from './utils'

export const ROUTE_BANDEJA_PRESUPUESTO = prefixerT('bandeja-presupuesto')
export const ROUTE_EDITAR_PRESUPUESTO = prefixerT('ver-presupuesto')
export const ROUTE_APROBAR_PRESUPUESTO = prefixerT('aprobar-presupuesto')
export const ROUTE_ALCANCE_PRESUPUESTO = prefixerT('alcance-presupuesto')
export const ROUTE_BANDEJA_SOLICITUD_ALCANCE = prefixerT('bandeja-solicitud-alcance')
export const ROUTE_APROBACION_ALCANCE_PRESUPUESTO = prefixerT('aprobacion-alcance-presupuesto')
